import { createActions } from 'redux-actions';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { CorporateUser } from '@models/User';
import { GetCorporateHealthOrderUsersParams, GetCorporateHealthOrderUserParams } from '@apis/CorporateHealthOrderApi';
import { Pagination } from '@models/Pagination';

import { InsurancePolicy } from '@models/InsurancePolicy';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { GetAllInsurancePolicyParams } from '@apis/InsurancePolicyApi';
import { SearchInsurancePolicyUserParams } from '@apis/InsurancePolicyUserApi';

export type State = {
  corporateHealthOrders?: CorporateHealthOrder[] | null;
  corporateHealthOrderUsers?: CorporateUser[] | null;
  corporateHealthOrderUser?: CorporateUser | null;
  pagination?: Pagination;
  showBenefitScheduleDialog: boolean;
  selectedCorporateUser: CorporateUser | null;
  isLoading: boolean;

  insurancePolicies?: InsurancePolicy[] | null;
  insurancePolicyUsers?: InsurancePolicyUser[] | null;
};

export type CorporateHealthOrderUsersFetchPayload = GetCorporateHealthOrderUsersParams;
export type CorporateHealthOrderUserFetchPayload = GetCorporateHealthOrderUserParams;

export type InsurancePoliciesFetchPayload = GetAllInsurancePolicyParams;
export type InsurancePolicyUsersFetchPayload = SearchInsurancePolicyUserParams;

export type StateUpdatePayload = Partial<State>;

export const {
  corporateHealthOrdersFetch,
  corporateHealthOrderUsersFetch,
  corporateHealthOrderUserFetch,

  insurancePoliciesFetch,
  insurancePolicyUsersFetch,

  stateUpdate,
} = createActions(
  'CORPORATE_HEALTH_ORDERS_FETCH',
  'CORPORATE_HEALTH_ORDER_USERS_FETCH',
  'CORPORATE_HEALTH_ORDER_USER_FETCH',

  'INSURANCE_POLICIES_FETCH',
  'INSURANCE_POLICY_USERS_FETCH',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_SEARCH_INSURANCE_POLICY_USER_PAGE',
  },
);
